import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "h-full relative shadow-md bg-white dark:bg-dark-400",
  style: {"border-radius":"1rem"}
}
const _hoisted_2 = { class: "text-base absolute top-0 left-0 ml-4 mt-3 text-gray-500 dark:text-dark-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.label), 1),
    _createElementVNode("div", {
      class: _normalizeClass(`${_ctx.fontSize} text-center flex items-center justify-center h-full mt-1`)
    }, _toDisplayString(_ctx.value), 3)
  ]))
}